import React from "react";

const TwoArrowDown = ({ size = 8, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.38665 8.34523L7.86621 5.20987C7.95565 5.10826 8.00345 4.97561 7.99981 4.83919C7.99616 4.70278 7.94133 4.57297 7.8466 4.47648C7.75186 4.37998 7.62443 4.32413 7.49051 4.32041C7.35659 4.3167 7.22636 4.36539 7.12661 4.45649L4.01008 7.26444L0.893557 4.45649C0.793807 4.36539 0.663578 4.3167 0.529657 4.32041C0.395736 4.32413 0.268304 4.37998 0.173572 4.47648C0.0788406 4.57297 0.0240105 4.70278 0.0203612 4.83919C0.016712 4.97561 0.0645206 5.10826 0.153953 5.20987L3.63352 8.34523C3.73754 8.45119 3.87381 8.50205 4.01008 8.49993C4.07981 8.50107 4.14906 8.48796 4.21373 8.46139C4.27841 8.43482 4.3372 8.39532 4.38665 8.34523ZM0.152914 0.655702C-0.050971 0.863384 -0.0509711 1.2014 0.152914 1.40908L3.63248 4.54444C3.7365 4.6504 3.87277 4.70126 4.00904 4.69914C4.07882 4.70061 4.14815 4.68766 4.21288 4.66107C4.2776 4.63448 4.33636 4.5948 4.38561 4.54444L7.86621 1.41014C7.95565 1.30853 8.00345 1.17588 7.99981 1.03946C7.99616 0.903046 7.94133 0.773241 7.8466 0.676745C7.75186 0.580249 7.62443 0.524399 7.49051 0.520682C7.35659 0.516965 7.22636 0.565664 7.12661 0.656762L4.01008 3.46471L0.893557 0.656762C0.795474 0.556587 0.662345 0.500199 0.523451 0.5C0.384557 0.499801 0.251273 0.555809 0.152914 0.655702Z"
      fill="white"
    />
  </svg>
);

export default TwoArrowDown;
